/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.17.3
 * @since 1.0.1
 */

import { FC } from 'react';

import { ChartPie } from '../../../../../../components/common';
import { IChartPieItem } from '../../../../../../components/common/Chart/ChartPie/chartPieTypes';
import { widgetCostsConfiguration } from '../constant/widgetCostsConstants';
import { IWidgetConfiguration } from '../types/widgetCostsType';

export interface IWidgetCostsChartProps {
    configuration: IWidgetConfiguration;
    currency: string;
    data: IChartPieItem[];
    total: number;
}

const WidgetCostsChart: FC<IWidgetCostsChartProps> = ({ children, configuration, currency, data, total }) => (
    <ChartPie
        currency={currency}
        data={data}
        innerRadius={configuration.chart.innerRadius}
        isEmpty={false}
        legendSize={configuration.chart.legendSize}
        padding={configuration.chart.padding}
        radius={configuration.chart.radius}
        size={configuration.chart.size}
        strokeColor={configuration.chart.strokeColor}
        total={total}
    >
        {children}
    </ChartPie>
);

WidgetCostsChart.defaultProps = {
    configuration: widgetCostsConfiguration,
};

export default WidgetCostsChart;
